import styled from "styled-components";

const FlowerInfoWrapper = styled.div`
  padding: 16px;
  border-bottom: 1px solid #f1f3f5;
  cursor: pointer;

  div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 4px 0;

    span {
      display: flex;
      align-items: center;

      p {
        margin-right: 4px;
      }
    }
  }
`;

const Text = styled.p`
  color: #4a5056;
  font-size: 0.75rem;
  font-size: regular;

  img {
    margin-right: 4px;
  }
`;

const StrongText = styled.strong`
  color: #222529;
  font-size: 1.125rem;
  font-weight: bold;
`;

export { FlowerInfoWrapper, Text, StrongText };
